import React, {Component} from 'react';
import {graphql} from 'react-apollo';
import createAddressMutation from 'graphql/mutations/addresses/create-address.gql';
import AddressForm from 'views/addresses/address-form';

@graphql(createAddressMutation, {
    props: ({mutate}) => ({
        onSubmit: variables => mutate({variables}),
    }),
})
export default class CreateAddress extends Component {
    render() {
        return (
            <AddressForm
                dataKey='createAddress'
                returnUrl={this.props.location.state && this.props.location.state.returnUrl}
                returnData={this.props.location.state && this.props.location.state.returnData}
                onSubmit={this.props.onSubmit}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./views/addresses/create-address/index.js